import React, {FC} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../libs/shared/core/src/models/api/teammateModel';
import {NewPanelId, RViewerPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {shadows} from '../../../libs/shared/ui/src/styles/colorStyles';
import {TeammateCardContentContainer} from './teammateCardContentContainer';
import {TeammateCardFooterActionsContainer} from './teammateCardFooterActionsContainer';
import {TeammateCardProfile} from './teammateCardProfile';

/*
 * Props.
 */

export interface TeammateCardProps {
  panelId: NewPanelId;
  teammate: TeammateModel;
  isUserVisitor: boolean;
}

/*
 * Types.
 */

interface StyledContentWrapperOptions {
  $isLastElement: boolean;
}

/*
 * Style.
 */

const StyledTeammateCard = styled.div`
  min-height: 100px;
  max-height: 500px;
  width: 320px;
  border-radius: 20px;
  background-color: ${(p) => p.theme.foreground};
  ${shadows.dialogsAndDropdowns};
`;

const StyledContentWrapper = styled.div<StyledContentWrapperOptions>`
  ${(p) => p.$isLastElement && 'padding-bottom: 5px;'};
`;

const StyledFooterActionWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

export const TeammateCard: FC<TeammateCardProps> = (props) => {
  const {teammate, panelId, isUserVisitor} = props;

  const isViewerPanelId = RViewerPanelId.is(panelId);

  return (
    <StyledTeammateCard>
      <TeammateCardProfile teammate={teammate} />
      <StyledContentWrapper $isLastElement={isUserVisitor}>
        <TeammateCardContentContainer teammate={teammate} />
      </StyledContentWrapper>
      {!isUserVisitor && isViewerPanelId && (
        <StyledFooterActionWrapper>
          <TeammateCardFooterActionsContainer teammate={teammate} panelId={panelId} />
        </StyledFooterActionWrapper>
      )}
    </StyledTeammateCard>
  );
};
